import React from 'react'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import 'moment/locale/pt-br'
import 'react-datepicker/dist/react-datepicker.css';
import $ from 'jquery';
import cadastrarItinerario from '../../actions/itinerario/cadastrarItinerario'
import alterarItinerario from '../../actions/itinerario/alterarItinerario'
import {renderFieldSelect, requiredSelect} from '../../util/inputs';
import alterarVeiculoItinerario from '../../actions/itinerario/alterarVeiculoItinerario';
import {showSuccessMsg} from '../../util/messagesUtil';
import { ativarItinerario, inativarItinerario } from '../../actions/itinerario/ativarOuInativarItinerario';
import { BotaoAtivarOuInativar } from './BotaoAtivarOuInativar';

const ANDARES = [{
  label: '1º Andar',
  value: 1
}, {
  label: '2º Andar',
  value: 2
}]

export class ModalAlterarVeiculoItinerario extends React.Component {
  constructor (props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.buscarItinerarios = this.buscarItinerarios.bind(this);
    this.fecharModal = this.fecharModal.bind(this);
  }

  buscarItinerarios () {    
    this.props.buscarItinerarios();
  }

  montarParametroItinerario (values) {
    return {
      id: this.props.itinerarioSelecionado.id,
      idVeiculo: values.veiculo.value.id,
      idEmpresa: this.props.empresaSelecionada.id,
      andar: values.veiculo.value.seDoisAndares ? values.andar.value : 1
    }
  }

  fecharModal () {
    $('#modalAlterarVeiculoItinerario')
      .modal('hide');
    $('#modalAlterarVeiculoItinerario')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.limparFormulario();
  }

  submit (values) {    
    const parametros = this.montarParametroItinerario(values)
    this.props.alterarVeiculoItinerario(parametros)
      .then(() => {
          showSuccessMsg('Itinerário alterado com sucesso');
          this.fecharModal();
          this.buscarItinerarios()
      })
  }


  limparFormulario () {
    this.props.reset('formularioAlterarVeiculoItinerario');
  }

  exibirComboVeiculo () {
    return <Field name='veiculo'
           options={this.props.veiculos.map(elemento => ({
             descricao: elemento.descricao,
             nome: elemento
           }))}
           component={renderFieldSelect}
           label="Veículo"
           placeholder='Selecione o veículo' validate={requiredSelect}/>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade show" id='modalAlterarVeiculoItinerario' role='dialog'
           aria-labelledby='modalAlterarVeiculoItinerario' aria-hidden='true' data-backdrop='static'>
        <div className={'modal-dialog modal-dialog-centered modal-xl'}>
          <div className="modal-content">
            <div className="modal-header">
              <h5>Alterar Veículo</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                      onClick={this.limparFormulario}>
                <i className="material-icons">
                  &#xe5cd;
                </i>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">                  
                  <div className="col-12 col-sm-9 col-md-9">
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-9">
                        {this.exibirComboVeiculo()}
                      </div>
                    </div>
                    <div className="form-row mt-2">
                      <div className="col-12 col-sm-9 col-md-9">
                        {this.exibirComboAndar()}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer mt-4">
                  {this.props.itinerarioSelecionado.id && <BotaoAtivarOuInativar 
                                                idItinerario={this.props.itinerarioSelecionado.id} 
                                                idEmpresa={this.props.itinerarioSelecionado.idEmpresa}
                                                ativo={this.props.itinerarioSelecionado.ativo}
                                                ativarItinerario={this.props.ativarItinerario}
                                                inativarItinerario={this.props.inativarItinerario}
                                                buscarItinerarios ={this.buscarItinerarios}
                                                fecharModal={this.fecharModal} />}
                  <button type="submit" disabled={invalid || submitting || pristine}
                          className="btn btn-laranja">Salvar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }


  exibirComboAndar () {
    if (this.props.veiculo && this.props.veiculo.value.seDoisAndares) {
      return <div>
        <Field name='andar'
               options={ANDARES.map(elemento => ({
                 descricao: elemento.label,
                 nome: elemento.value
               }))}
               component={renderFieldSelect}
               label='Andar'
               placeholder='Selecione o andar' validate={requiredSelect}/>
      </div>
    }
  }
}

export function mapStateToProps (state) {  
  return {
    veiculo: formValueSelector('formularioAlterarVeiculoItinerario')(state, 'veiculo'),
    empresaSelecionada: state.empresaSelecionada,
    itinerarioSelecionado: state.itinerarioSelecionado,
    tiposPreco: state.tiposPreco,
    veiculos: state.veiculos.veiculos,
    paginaAtual: state.paginaAtualItinerario,
    registrosPorPagina: state.registrosPorPaginaItinerario,
    rotaSelecionada: state.rotaSelecionada

  }
}


export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    changeFieldValue,
    cadastrarItinerario,    
    alterarItinerario,
    alterarVeiculoItinerario,
    ativarItinerario,
    inativarItinerario
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'formularioAlterarVeiculoItinerario',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(ModalAlterarVeiculoItinerario));
